import { useCallback } from 'react';
import { ProfileFilesService } from '../services/ProfileFilesService';
import { useLoadingContext } from '../contexts/LoadingContext';

type ProfileFilesParams = {
  getUserToken: () => string | undefined | Promise<string | undefined>;
  setProfileFilesError: (value: string | null) => void;
  setProfileFiles: (items: any[]) => void;
};

export const useProfileFiles = (params: ProfileFilesParams) => {
  const { beginLoadingKey } = useLoadingContext();

  const loadProfileFiles = useCallback(async (accessToken: string) => {
    if (!accessToken) return;
    const stopLoading = beginLoadingKey('profileFilesLoad');
    try {
      params.setProfileFilesError(null);
      const items = await ProfileFilesService.listProfileFiles(accessToken);
      params.setProfileFiles(items);
    } catch (err: any) {
      console.error('Profile-Dateien konnten nicht geladen werden', err);
      params.setProfileFilesError(err?.message ?? 'Unbekannter Fehler');
    } finally {
      stopLoading();
    }
  }, [beginLoadingKey, params]);

  const handleReloadProfileFiles = useCallback(async () => {
    const token = await params.getUserToken();
    await loadProfileFiles(token as string);
  }, [params, loadProfileFiles]);

  return { loadProfileFiles, handleReloadProfileFiles };
};
